import * as React from "react";

function SvgSearch(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.327 15.501a9.945 9.945 0 001.656-5.51C19.983 4.473 15.509 0 9.99 0 4.473 0 0 4.473 0 9.991s4.473 9.992 9.991 9.992c2.037 0 3.93-.61 5.51-1.656l5.088 5.088a1.998 1.998 0 102.826-2.826L18.327 15.5zm-1.342-5.51a6.994 6.994 0 11-13.988 0 6.994 6.994 0 0113.988 0z"
        fill="#F7A246"
      />
    </svg>
  );
}

export default SvgSearch;
